<template>
  <div class="container-fluid">
    <div
      class="row mt-1 rounded"
      :style="{ backgroundColor: corPrimariaTopoLogin }"
    >
      <div class="container col-12">
        <img v-if="urlLogo" :src="urlLogo" class="logo-cliente mx-auto d-block"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-12 offset-md-3 offset-lg-3">
        <div id="login" :style="{ borderColor: `${corTextoPrimaria} !important`, border:'1px solid' }">

          <!-- <div class="container2"> -->
            <div
              id="login-row"
              class="row justify-content-center align-items-center"
            >
              <div id="login-column" class="col-md-8">
                <div
                  id="login-box"
                  :style="{ borderColor: `${corTextoPrimaria} !important` }"
                >
                  <form
                    id="login-form"
                    class="form">
                    <h3
                      class="text-center text-info"
                      :style="{ color: `${corTextoPrimaria} !important` }"
                    >
                      Identificação
                    </h3>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            for="username"
                            class="text-info"
                            :style="{ color: `${corTextoPrimaria} !important` }"
                            >CPF:</label
                          ><br />
                          <input
                            type="text"
                            name="cpf"
                            v-model="pessoa.cpf"
                            placeholder="Informe seu CPF"
                            id="cpf"
                            v-mask="'###.###.###-##'"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            for="password"
                            class="text-info"
                            :style="{ color: `${corTextoPrimaria} !important` }"
                            >Data nascimento</label
                          ><br />
                          <input
                            type="text"
                            v-model="pessoa.dataNascimento"
                            v-mask="'##/##/####'"
                            placeholder="DD/MM/AAAA"
                            name="dataNascimento"
                            id="dataNascimento"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
<hr>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <input
                            type="button"
                            name="btnEntrar"
                            class="btn btn-info btn-md"
                            :style="{
                              background: `${corTextoPrimaria} !important`,
                            }"
                            @click="handleEfetuarLogin"
                            value="Entrar"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="text-right">
                          <router-link
                            class="text-info"
                            :style="{
                              color: `${corTextoPrimaria} !important`,
                            }"
                            :to="{
                              name: 'PrimeiroAcesso',
                              params: {
                                apelidoCliente: `${cliente.apelidoUnico}`,
                              },
                            }"
                          >
                            Primeiro Acesso
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div v-if="codigoCliente">
      {{ verificarAtendimentoEmPausa() }}
    </div>
  </div>
</template>

<script>
import loginService from "../services/LoginService";
import notificacaoService from "../services/Notificacao.service";
import storageService from "../services/storageService";
import { USER_CONFIG } from "../config/UserConfig";

import { configuracaoTemaMixin } from "../components/ConfiguracaoTemaMixin";

export default {
  mixins: [configuracaoTemaMixin],
  name: "LoginPage",
  methods: {
    async handleEfetuarLogin() {
      const { pessoa } = this;
      const pessoaLogin = { ...pessoa };

      const [dia, mes, ano] = pessoaLogin.dataNascimento.split("/");

      pessoaLogin.cpf = pessoaLogin.cpf.replace(/\D/gm, "");
      pessoaLogin.dataNascimento = `${ano}-${mes}-${dia}`;
      pessoaLogin.codigoCliente = this.codigoCliente;

      this.$loading(true);
      const { retorno, sucesso, erros } = await loginService.efetuarLogin(
        pessoaLogin
      );

      if (sucesso) {
        //atualizar
        this.$loading(false);
        this.$store.dispatch("adicionarPessoa", retorno);
        this.$store.dispatch("adicionarTokenSessao", retorno);
        storageService.setJsonItem(USER_CONFIG.loggedUser, retorno);

        notificacaoService.sucesso("Login efetuado com sucesso").then(() => {
          this.$router.push({
            name: "RedirecionarPage",
            params: { apelidoCliente: this.cliente.apelidoUnico },
          });
        });
      } else {
        notificacaoService.erro(erros);
        this.$loading(false);
      }
    },
    verificarAtendimentoEmPausa() {
      const { clienteFormulario } = this.$store.state;
      if (
        clienteFormulario &&
        clienteFormulario.atendimentoPausa &&
        clienteFormulario.urlAtendimentoPausa
      ) {
        window.location = clienteFormulario.urlAtendimentoPausa;
        return;
      }
    },
  },
  data() {
    return {
      pessoa: {
        //nome:'',
        cpf: "",
        dataNascimento: "",
      },
      apelidoClienteUnico: "",
    };
  },
  computed: {
    codigoCliente() {
      const { clienteFormulario } = this.$store.state;
      return clienteFormulario.codigoCliente;
    },
    cliente() {
      return storageService.getJsonItem(USER_CONFIG.clienteFormulario);
    },
  },

  mounted() {
    this.verificarAtendimentoEmPausa();

    const participante = storageService.getJsonItem(USER_CONFIG.loggedUser);
    const tokenParticipante = storageService.getItem(USER_CONFIG.token);

    if (
      participante &&
      participante.pessoaId &&
      participante.pessoaId.length &&
      tokenParticipante &&
      tokenParticipante.length
    ) {
      //validar o token
      loginService.validarToken(tokenParticipante).then((result) => {
        if (result.retorno) {
          this.$router.push({
            name: "RedirecionarPage",
            params: { apelidoCliente: this.cliente.apelidoUnico },
          });
        }
      });
    }
  },
};
</script>

<style scoped>
.logo-cliente {
  max-width: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100% !important;
}
#login  {
  margin-top: 2rem;
  max-width: 600px;
  /* height: 20.1rem; */
  /* border: 1px solid #9c9c9c; */
  background-color: #eaeaea;
  padding: 15px;
}


</style>




// WEBPACK FOOTER //
// src/View/LoginPage.vue